import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid #e7e7f0;
    border-radius: 12px;
    margin-top: 20px;
    padding: 20px;
`;

export const PlanDetailsFlex = styled.div`
    display: flex;
`;

export const PlanName = styled.div`
    display: flex;
    flex: 2;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: #040222;
`;

export const Premium = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: #040222;
`;

export const DeviceName = styled.div`
    display: flex;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    color: #5b5675;
    margin-top: 8px;
`;

export const IMEI = styled.div`
    display: flex;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    color: #5b5675;
    margin-top: 8px;
`;

export const Hr = styled.div`
    display: flex;
    height: 0px;
    border: 1px solid #e7e7f0;
    margin-top: 20px;
`;

export const PaidBy = styled.div`
    display: flex;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    color: #040222;
    margin-top: 20px;
`;

export const Label = styled.div`
    display: flex;
    margin-top: 24px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #5b5675;
`;

export const Value = styled.div`
    display: flex;
    margin-top: 6px;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #040222;
`;
